<template>
  <div id="mypage-community-list-template">
    <li class="my-cummunity gutter-20__li grid-4" v-for="list in communityList">
      <a href="#" class="my-cummunity__link request_link embed-responsive embed-responsive-4by3" title="운영자 요청 중 {{list.name}}"> <!-- @click="isAdminApprove(list.id, list.org)" -->
        <div class="my-cummunity-card board-card__media background-image"
             :style="`background-image: url(${list.imgUrl})`">
          <div class="my-cummunity-card__bg">
            <label class="my-cummunity-card__label">운영자 요청 중</label>
            <h4 class="my-cummunity-card__title">{{list.name}}</h4>
          </div>
        </div>
      </a>
    </li>
  </div>
</template>
<script>
  /* import Axios from 'axios'; */

  export default {
    name: 'mypage-community-list-template',
    props: ['communityList'],
    data() {
      return {
        url: '',
        status: '',
      };
    },
    methods: {
      /*
      isAdminApprove(id, communityOrg) {
        const result = window.confirm('해당 커뮤니티 운영자 요청을 승인하시겠습니까? 취소시에는 거절됩니다.');
        if (result) {
          this.url = `/api/communities/${id}/operators-approve`;
          this.status = 'approve';
        } else {
          this.url = `/api/communities/${id}/operators-reject`;
          this.status = 'reject';
        }
        Axios.put(this.url, {}, { params: { org: communityOrg } }).then(() => {
          if (this.status === 'approve') {
            alert('승인되었습니다.');
            location.reload();
          } else {
            alert('거절되었습니다.');
            location.reload();
          }
        }).catch((e) => {
          alert(e.data.msg);
        });
      },
      */
    },
    mounted() {
      /* console.log(this.communityList); */
    },
  };
</script>


// WEBPACK FOOTER //
// CommunityJoinList.vue?b3cb76a2